/* Voice-call API client.
   Wraps /api/calls/* endpoints. Real-time call events
   (call:incoming, call:answered, call:rejected, call:ended)
   already arrive via the existing messaging SSE stream. */
import { api } from "./api";

export const getCallConfig = () =>
  api.get("/calls/config").then((r) => r.data);

export const startCall = ({ conversation_id, callee_id }) =>
  api
    .post("/calls/start", { conversation_id, callee_id })
    .then((r) => r.data);

export const answerCall = (callId) =>
  api.post(`/calls/${callId}/answer`).then((r) => r.data);

export const rejectCall = (callId) =>
  api.post(`/calls/${callId}/reject`).then((r) => r.data);

export const cancelCall = (callId) =>
  api.post(`/calls/${callId}/cancel`).then((r) => r.data);

export const endCall = (callId, reason = "hangup") =>
  api.post(`/calls/${callId}/end`, { reason }).then((r) => r.data);

export const getCall = (callId) =>
  api.get(`/calls/${callId}`).then((r) => r.data);

export const listRecentCalls = (limit = 50) =>
  api.get(`/calls/recent`, { params: { limit } }).then((r) => r.data);
